import { useQuery } from '@tanstack/react-query';
import { getLogo } from 'services/logo';

export function useLogo() {
  return useQuery(['customer-logo'], () => getLogo());
}
